import React, { useState } from 'react';
import { createPortal } from 'react-dom';
import Swal from 'sweetalert2';
import axiosInstance from '../../../../../interceptor/axiosInstance';
import './CloneButton.css';

const CloneButton = ({ test_id, test_name }) => {
  const [showPopup, setShowPopup] = useState(false);
  const [newTestName, setNewTestName] = useState(test_name);
  const [loading, setLoading] = useState(false);

  const handleCloneClick = () => {
    setShowPopup(true);
  };

  const handleClosePopup = () => {
    setShowPopup(false);
  };

  const handleSubmit = async () => {
    setLoading(true);
    try {
      await axiosInstance.post('/assessments/clone/', { test_id, test_name: newTestName });

      Swal.fire({
        title: 'Success!',
        text: 'Test has been cloned successfully. If you do not see the test, please refresh the page.',
        icon: 'success',
      });

      setShowPopup(false); // Close popup after successful cloning
    } catch (error) {
      console.log(error);
      const errorMessage = error.response?.data?.error || 'An error occurred. Please try again later.';

      Swal.fire({
        title: 'Error',
        text: errorMessage,
        icon: 'error',
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div>
      <button className="assessments-button" onClick={handleCloneClick}>
        Clone
      </button>

      {showPopup && createPortal(
        <div className="mcq-clone-modal-overlay">
          <div className="mcq-clone-modal-content">
            <div className="mcq-clone-modal-header">
              <h2>Clone Assessment</h2>
              <p>Create a duplicate assessment with a new test name.</p>
            </div>

            <label htmlFor={`clone-name-${test_id}`} className="mcq-clone-modal-label">New Test Name</label>
            <input
              id={`clone-name-${test_id}`}
              type="text"
              value={newTestName}
              onChange={(e) => setNewTestName(e.target.value)}
              className="mcq-clone-modal-input"
              placeholder="Enter new test name"
            />

            <div className="mcq-clone-modal-actions">
              <button className="mcq-clone-btn mcq-clone-btn-primary" onClick={handleSubmit} disabled={loading}>
                {loading ? 'Cloning...' : 'Clone'}
              </button>
              <button className="mcq-clone-btn mcq-clone-btn-secondary" onClick={handleClosePopup}>
                Cancel
              </button>
            </div>
          </div>
        </div>,
        document.body
      )}
    </div>
  );
};

export default CloneButton;
